import React, { useState, useEffect, useCallback } from 'react';
import './paypal.css';
import useApiRequest from '../../../utils/helperFunctions';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';

const queryParams = new URLSearchParams(window.location.search);

const url_orderId = queryParams.get('oid') || queryParams.get('OrderId');
const url_service = queryParams.get('Service');
const url_amount = queryParams.get('Amount');
// const url_countryCode = queryParams.get('CC') || 'USD';

const BreakDownEntry = ({ details }) => (
  <li>
    <span className={details.icon}></span>
    <div className="list-content">
      <p>
        {details?.text}
        <span className="list-bold">{details?.main}</span>
      </p>
    </div>
  </li>
);

const Breakdown = ({ breakdown }) => {
  const pathnameParts = window.location.pathname.split('/');
  let lastPart = pathnameParts.pop();
  const words = lastPart.split('-');
  words.pop();
  const formattedName = words
    .join(' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <div className="card-breakdown">
      <div className="card-breakdown--header">
        <p>Receipt for</p>
        <h2>{formattedName + ' Service'}</h2>
      </div>
      <ul className="card-breakdown--list">
        {breakdown.map((item, index) => (
          <BreakDownEntry key={index} details={item} />
        ))}
      </ul>
    </div>
  );
};

const OverviewHeader = ({ logo }) => {
  const [currentTime, setCurrentTime] = useState({
    date: '',
    time: '',
  });

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const formattedDate = now.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      });
      const formattedTime = now.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZoneName: 'short',
      });
      const [time, timeZone] = formattedTime.split(' ');
      setCurrentTime({ date: formattedDate, time: `${time} ${timeZone}` });
    };

    updateTime();
    const intervalId = setInterval(updateTime, 1000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      <div className="overview-header">
        <img
          className="logo"
          src={logo}
          alt="Razorpay Logo"
          style={{visibility: 'hidden', opacity: "0"}}
        />
        <div className="timestamp">
          <span>{currentTime.date}</span>
          <span>{currentTime.time}</span>
        </div>
      </div>
      <hr />
    </>
  );
};

const OverviewBody = ({ product, value, name, merchant, merchantEmail, handleRazorpayPayment }) => (
  <div className="overview-body">
    <div className="purchase-overview">
      <h3>{product}</h3>
      <p>Total: {value}</p>
    </div>
    <div className="user-info">
      <p className="user-info-name">Hello {name || 'User'},</p>
      <span>Click below to proceed with secure payment:</span>
      {/* Cashfree Payment Button */}
      <div id="cashfree-button-container" style={{ marginTop: "20px" }}>
        <button
          onClick={handleRazorpayPayment}
          style={{
            padding: "12px 24px",
            fontSize: "16px",
            cursor: "pointer",
            backgroundColor: "#2361d5",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            transition: "background-color 0.3s ease",
            width: "100%"
          }}
        >
          Verify & Pay
        </button>
      </div>
    </div>
    <div className="descriptor">
      <p>
        It may take a few moments for this transaction to appear in your account
      </p>
    </div>
  </div>
);

const OverviewFooter = ({ invoiceId }) => (
  <footer className="overview-footer">
    <span className="site">
      <a href="https://razorpay.com/support/" target="_blank" rel="noopener noreferrer">
        https://razorpay.com/support/
      </a>
    </span>
  </footer>
);

const Overview = (props) => {
  console.log("props------------", props)
  return <div className="card-overview">
    <OverviewHeader logo="https://razorpay.com/newsroom-content/uploads/2020/12/output-onlinepngtools-1-1.png" />
    <OverviewBody {...props} />
    <OverviewFooter invoiceId={props.invoiceId} />
  </div>
};

const CashfreePayment = (props) => {
  const [breakdown, setBreakdown] = useState([]);
  const { apiRequest } = useApiRequest();
  const navigate = useNavigate();
  useEffect(() => {
    const dynamicBreakdown = [
      {
        text: 'Date:',
        main:
          props?.info?.date ||
          new Date().toLocaleDateString('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
          }),
      },
      { text: 'Issuer:', main: 'Stagobox' },
      { text: 'Order ID:', main: props?.info?.orderId || url_orderId || 'N/A' },
      {
        text: 'Amount:',
        main: `${props?.final_amount || url_amount} ${props?.info.symbol}`,
      },
    ];

    setBreakdown(dynamicBreakdown);
  }, [props]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);


  const handlePaymentDetail = useCallback(async (data) => {
    try {
      const resp = await apiRequest({
        url: 'payment-details',
        method: 'POST',
        showMessage: true,
        payload: data,
      });
      if (resp.status === 201) {
        message.success('Payment has been processed successfully.');
        setTimeout(() => {
          window.open('/thank-you');
        }, 1000);
      } else {
        message.error('Failed to save payment details, Please try again later.');
        setTimeout(() => {
          window.location.reload();
        }, 800);
      }
    } catch (errors) {
      message.error('Failed to save payment details');
      setTimeout(() => {
        window.location.reload();
      }, 800);
    }
  }, [apiRequest]);

  // // Handle payment success callback (if using return URL)
  // const handlePaymentSuccess = useCallback(async (orderId) => {
  //   try {
  //     message.loading('Verifying payment...', 0);
      
  //     // Verify payment status with your backend
  //     const verificationResponse = await apiRequest({
  //       url: `razorpay-verify-payment/`,
  //       method: 'GET',
  //     });

  //     message.destroy();

  //     if (verificationResponse.data.order_status === 'PAID') {
  //       const paymentData = {
  //         order_id: orderId,
  //         amount: props?.final_amount || url_amount,
  //         status: 'PAID',
  //       };
  //       handlePaymentDetail(paymentData);
  //     } else {
  //       message.error('Payment verification failed. Please contact support.');
  //     }
  //   } catch (error) {
  //     message.destroy();
  //     console.error('Payment verification error:', error);
  //     message.error('Unable to verify payment status. Please contact support.');
  //   }
  // }, [apiRequest, props?.final_amount, handlePaymentDetail]);

  // // Check for payment return from Cashfree
  // useEffect(() => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const orderIdFromUrl = urlParams.get('order_id');
  //   const paymentStatus = urlParams.get('payment_status');
    
  //   // If user returns from Cashfree payment page
  //   if (orderIdFromUrl && paymentStatus === 'completed') {
  //     message.loading('Processing payment...', 0);
      
  //     // Verify payment immediately
  //     setTimeout(() => {
  //       handlePaymentSuccess(orderIdFromUrl);
  //     }, 1000); // Small delay to ensure payment is processed
  //   }
  // }, [handlePaymentSuccess]);

  const handleRazorpayPayment = async () => {
  let loadingKey;

  const extractErrorMessage = (err) => {
    try {
      if (err?.response?.data?.message) return err.response.data.message;
      if (err?.response?.data?.error) return err.response.data.error;

      if (err?.request?.response) {
        const parsed = JSON.parse(err.request.response);
        return parsed?.message || parsed?.error;
      }

      return err?.message || 'Something went wrong';
    } catch {
      return 'Something went wrong';
    }
  };

 let closeLoading;

try {
  closeLoading = message.loading('Initializing payment...', 0);

  const internalOrderId =
    props?.info?.orderId || url_orderId || `${Date.now()}`;

  const orderRes = await apiRequest({
    url: 'razorpay-order-payment/',
    method: 'POST',
    payload: {
      order_id: internalOrderId,
      amount: props?.final_amount || url_amount,
      email: props?.details?.email || '',
      name: props?.details?.name || props?.info?.name || 'Customer',
      phone: props?.details?.phone || '',
    },
  });

  const {
    razorpay_order_id,
    key_id,
    amount,
    currency,
    customer_details,
  } = orderRes?.data || {};

  if (!razorpay_order_id || !key_id) {
    throw new Error('Invalid Razorpay order response');
  }

  // ✅ CLOSE loading properly
  closeLoading();

  const options = {
    key: key_id,
    amount: Number(amount) * 100,
    currency,
    name: 'Stagobox',
    description: 'Service Payment',
    order_id: razorpay_order_id,

    prefill: {
      name: customer_details?.name,
      email: customer_details?.email,
      contact: customer_details?.phone,
    },

    handler: async function (rzpResponse) {
      let closeVerify;

      try {
        closeVerify = message.loading('Verifying payment...', 0);

        const verifyRes = await apiRequest({
          url: 'razorpay-verify-payment/',
          method: 'POST',
          payload: {
            razorpay_order_id: rzpResponse.razorpay_order_id,
            razorpay_payment_id: rzpResponse.razorpay_payment_id,
            razorpay_signature: rzpResponse.razorpay_signature,
          },
        });

        closeVerify();

        if (verifyRes?.data?.status === 'captured') {
          navigate('/thank-you');
        } else {
          message.error('Payment verification failed');
        }
      } catch (err) {
        closeVerify?.();
        message.error(extractErrorMessage(err));
      }
    },

    modal: {
      ondismiss: () => {
        message.warning('Payment cancelled');
      },
    },
  };

  const razorpay = new window.Razorpay(options);
  razorpay.open();

} catch (err) {
  closeLoading?.(); // ✅ important
  message.error(extractErrorMessage(err));
}
};

  return (
    <div>
      <div className="paypal-card">
        {url_amount ? null : <Breakdown breakdown={breakdown} />}
        <Overview
          product="Amount to be paid :"
          merchant="Stagobox"
          merchantEmail="support@stagobox.com"
          name={props?.details?.name || url_service}
          value={`${props?.final_amount || url_amount} ${props?.info.symbol}`}
          invoiceId={`${props?.info?.orderId || url_orderId}`}
          handleRazorpayPayment={handleRazorpayPayment}
        />
      </div>
    </div>
  );
};

export default CashfreePayment;
